import { AttributeCode } from './attributeCode';
import { Schema } from 'effect';

export const CheckboxFilterValue = Schema.Union([Schema.Literal(true), Schema.Literal(false)]);

export type CheckboxFilterValue = Schema.Schema.Type<typeof CheckboxFilterValue>;

// Simplified structure: direct mapping from AttributeCode to CheckboxFilterValue
export const CheckboxFilterStateMap = Schema.HashMap(AttributeCode, CheckboxFilterValue);

export type CheckboxFilterStateMap = Schema.Schema.Type<typeof CheckboxFilterStateMap>;
